<script>
import ListChat from "@/components/contactos/ListChat.vue";
import ListContactos from "@/components/contactos/ListContactos.vue";
import DetalleContacto from "@/components/contactos/DetalleContacto.vue";
import DetalleChat from "@/components/contactos/DetalleChat.vue";
import { mapActions, mapState } from "vuex";
import { GET_LISTA_CHAT_INDIVIDUAL, GET_LISTA_CHAT_GRUPAL } from "../../graphql/queries";
import { GET_LISTA_CHATS_SUB } from "../../graphql/subscriptions";

export default {
	apollo: {
		listaChatIndividual: {
			query: GET_LISTA_CHAT_INDIVIDUAL,
			variables() { 
				return { id_empresa: this.id_empresa, id_usuario: this.id_usuario } 
			},
			update: data => data.listaChats
		},
	
		listaChatGrupal: {
			query: GET_LISTA_CHAT_GRUPAL,
			variables() {
				return { id_empresa: this.id_empresa, id_usuario: this.id_usuario } 
			},
			update: data => data.listaChats
		}	
	},

	props: {
		show: {
			type: Boolean,
			required: true
		}
	},

	components: {
		ListChat,
		ListContactos,
		DetalleContacto,
		DetalleChat
	},

	data() {
		return {
			id_empresa: this.$ls.get("user").id_empresa_fk,
			id_usuario: this.$ls.get("user").id_usuario,
			chats: [],
			chatsByType: { individual: [], grupal: [] },
			contacto: {},
			chat: {},
			contactoDetalle: false,
			chatDetalle: false,
			filter: {
				search: "",
				favorites: false,
				visibles: "personas"
			},
			show_spinner: false
		};
	},

	watch: {
		listaChatIndividual(data) {
			// console.log("new data INDIVIDUAL:", data);
			this.chatsByType.individual = data;
			this.chats = this.chatsByType.grupal.concat(this.chatsByType.individual);
		},

		listaChatGrupal(data) {
			// console.log("new data GRUPAL:", data);
			this.chatsByType.grupal = data;
			this.chats = this.chatsByType.grupal.concat(this.chatsByType.individual);
		}
	},

	async created() {
		await this.getListaContactos();
	},

	mounted() {	
		this.$apollo.queries.listaChatIndividual.subscribeToMore({
			document: GET_LISTA_CHATS_SUB,
			variables: {
				id_empresa: this.id_empresa, 
				id_usuario: this.id_usuario, 
				limit: "1" 
			},
			updateQuery: this.updateChatsQuery("individual")
		});

		this.$apollo.queries.listaChatGrupal.subscribeToMore({
			document: GET_LISTA_CHATS_SUB,
			variables: {
				id_empresa: this.id_empresa, 
				id_usuario: this.id_usuario, 
				limit: "1" 
			},
			updateQuery: this.updateChatsQuery("grupal")
		});

	},

	computed: {
		...mapState("ChatModule", ["listaContactos"]),

		contactosFilter() {
			const low = new RegExp(this.filter.search, "i");
			const result = this.listaContactos.filter(c => low.test(c.primer_nombre) || low.test(c.apellido_paterno) || low.test(c.cargo.nombre_cargo));
			// if (this.filter.favorites) {
			// 	return result.filter(element => element.favorito);
			// }
			return result;
		},
		interlocutors() {
			return this.chats.map(chat => chat.usuarios.find(usr => usr.id_usuario !== this.id_usuario));
		},
		chatFilter() {
			const low = new RegExp(this.filter.search, "i");
			const resultInterlocutors = this.interlocutors.filter(user => (user !== undefined) && (low.test(user.primer_nombre) || low.test(user.apellido_paterno)));
			const resultChats = this.chats.filter(chat => resultInterlocutors.some(interloc => chat.usuarios.some(usr => usr.id_usuario === interloc.id_usuario)));
			if (this.filter.favorites) {
				return resultChats.filter(element => element.is_favorito);
			}
			return resultChats;
		}
	},
	methods: {
		...mapActions("ChatModule", ["getContactos"]),

		updateChatsQuery(chatType) {
			const vm = this;
			return (previousResult, { subscriptionData }) => {
				if (!previousResult) return;
				if (!subscriptionData.data) return previousResult;

				const chatsUpdate = subscriptionData.data.ListaChatsSuscripcion[chatType];					
				const chatsIds = previousResult.listaChats.map(chat => chat.id_chat);

				/* METER NUEVOS (POSIBLES) CHATS */
				const newChats = chatsUpdate.filter(possiblyNewChat => !chatsIds.includes(possiblyNewChat.id_chat));
				previousResult.listaChats.unshift(...newChats);

				if (newChats.length !== 0 && Object.keys(this.chat).length !== 0) {
					const interlocutor = this.chat.usuarios.find(user => user.id_usuario !== this.id_usuario);
					console.log("interlocutor", interlocutor);
					const openedNewChat = newChats.find(
						chat => chat.usuarios.some(user => user.id_usuario === interlocutor.id_usuario)
					);
					if (openedNewChat) this.chat = openedNewChat;					
				}

				/* METER NUEVO MENSAJE A CHAT VIEJO */
				previousResult.listaChats.forEach((chat, idx, arr) => {
					const chatWithPossiblyNewMsg = chatsUpdate.find(c => c.id_chat === chat.id_chat);

					// Si chat no está en previousResult, i.e. fue eliminado, hay que removerlo del resultado
					if (!chatWithPossiblyNewMsg) {
						arr.splice(idx, 1);
						return;
					}

					// Actualiza chat con metadata nueva (fecha_modificacion, is_favorito, etc)
					const { mensajes, ...updatedChatMetadata } = chatWithPossiblyNewMsg;
					Object.assign(chat, updatedChatMetadata);

					const lastEmittedMsg = mensajes[0];
					if (!lastEmittedMsg) return;

					// Cambiamos instantáneamente el mensaje a visto si usuario está en pantalla de DetalleChat
					if (vm.chatDetalle) lastEmittedMsg.visto_mensaje = "1";

					// Vemos sólo últimos mensajes para ahorrar memoria
					const msgsIds = chat.mensajes.slice(0,5).map(msg => msg.id_chat_mensaje);

					// Comparamos con mensajes que están en el front para ver si el mensaje recibido de la suscripción es nuevo
					// Si no hay mensajes nuevos (i.e. el mensaje que llega de la suscripción ya está contenido en previousResults)
					// reemplaza el msg que está en el front por el del back (dado que puede contener metadata actualizada: visto_mensaje, etc)
					if (!msgsIds.includes(lastEmittedMsg.id_chat_mensaje)) {
						chat.mensajes.unshift(lastEmittedMsg);
					} else {
						const lastFrontMsgIdx = chat.mensajes.findIndex(msg => msg.id_chat_mensaje === lastEmittedMsg.id_chat_mensaje);
						chat.mensajes[lastFrontMsgIdx] = lastEmittedMsg;
					}
				});

				return { ...previousResult };
			}

		},

		//GET
		async getListaContactos() {
			const payload = {
				id_empresa: this.id_empresa,
				nombre_buscar: "",
				id_gerencia: ""
			};
			const res = await this.getContactos(payload);
			if (!res) {
				this.toastGenericError();
			}
		},

		//btn "Enviar Mensaje" dentro del detalle del contacto.
		async enviarMensaje(contacto) {
			const foundChat = this.chats.find(chat => chat.usuarios.some(user => user.id_usuario === contacto.id_usuario));
			
			if (!foundChat) {
				this.chat = {
					// Chat con contacto seleccionado no existe. Se crea un objeto temporal
					is_favorito: false,
					usuarios: [{
						id_usuario: this.id_usuario,
						primer_nombre: this.$ls.get("user").primer_nombre,
						apellido_paterno: this.$ls.get("user").apellido_paterno,
						imagen_perfil: this.$ls.get("user").imagen_perfil,
						cargo: this.$ls.get("user").cargo
					}, {
						id_usuario: contacto.id_usuario,
						primer_nombre: contacto.primer_nombre,
						apellido_paterno: contacto.apellido_paterno,
						imagen_perfil: contacto.imagen_perfil,
						cargo: contacto.cargo
					}],
					mensajes: []
				};
			} else {
				// Chat con contacto seleccionado existe
				this.chat = foundChat;
			}

			//Cambio de pestaña y entra al detalle del chat.
			this.filter.visibles = "chat";
			this.chatDetalle = true;
		},

		//Toggle de favoritos en la lista de contactos
		favoriteState() {
			this.filter.favorites = !this.filter.favorites;
		},
		//Selecciona el contacto desde la lista de contactos.
		contactoSeleccionado(data) {
			this.contacto = data;
			this.contactoDetalle = true;
		},
		//Volver a la lista de contactos desde la vista detalle.
		volverListaContactos() {
			this.contactoDetalle = false;
		},

		//Selecciona un chat desde la lista de chats.
		chatSeleccionado(data) {
			this.chat = data;
			this.chatDetalle = true;
		},

		//Para volver a la lista de chats desde la vista detalle de chat.
		volverListaChats() {
			this.chat = {};
			this.chatDetalle = false;
		},

		//Elimina un chat desde la vista detalle chat.
		chatDeleted() {
			this.chat = {};
			this.chatDetalle = false;			
		}
	}

}
</script>

<template>
<section 
	id="slide-contactos" 
	class="slide-right d-flex flex-column p-4"
	:class="{ 'slide-right-show': show }"
>
	<div class="d-flex justify-content-between align-items-center mb-4">
		<h4 
			v-if="filter.visibles === 'personas'"
			class="d-flex align-items-center font-700 color-main">
			<img width="50" height="50" src="@/assets/img/intranet/layout/contactos.svg">
			Contactos
		</h4>
		<h4 
			v-if="filter.visibles === 'chat'"
			class="d-flex align-items-center font-700 color-main">
			<img width="50" height="50" src="@/assets/img/intranet/layout/chat.png">
			Chat
		</h4>
		<div 
			class="btn-group btn-group-custom" 
			role="group"
			>
			<input 
				value="personas"
				v-model="filter.visibles"
				type="radio" 
				class="btn-check btn-group-custom-check" 
				name="filtro-contactos" 
				id="radio-personas" 
				autocomplete="off" 
				checked
			>
			<label 
				class="btn btn-group-custom-label btn-group-custom-label-small" 
				for="radio-personas">
				Contactos
			</label>

			<input 
				value="chat"
				v-model="filter.visibles"
				type="radio" 
				class="btn-check btn-group-custom-check" 
				name="filtro-contactos" 
				id="radio-chat" 
				autocomplete="off"
			>
			<label 
				class="btn btn-group-custom-label btn-group-custom-label-small" 
				for="radio-chat"
				>
				Chat
			</label>
		</div> 
	</div>

	<div class="d-flex">
		<div class="flex-grow-1 input-display input-display-left-flex mb-3 m-lg-0">
			<input 
				type="search" 
				class="form-control input-filter" 
				placeholder="Buscar"
				v-model="filter.search"
				>
			<font-awesome-icon icon="fa-solid fa-magnifying-glass" class="input-display-icon color-gray" ></font-awesome-icon>
		</div>
		<div class="ms-3">
			<a 
				class="btn-favourite"
				:class="[ filter.favorites ? 'active' : '' ]"
				href="javascript:"
				@click="favoriteState()"
			>
			<font-awesome-icon icon="fa-solid fa-star" ></font-awesome-icon>
			</a>
		</div>
	</div>

	<template v-if="filter.visibles === 'personas'">
		<template v-if="!contactoDetalle">
			<div class="row mt-3">
				<div class="col-12">
					<ListContactos 
						:contactos="contactosFilter"
						@contactoSeleccionado="contactoSeleccionado"
					/>
				</div>
			</div>
		</template>
		
		<template v-if="contactoDetalle">
			<div class="row mt-3">
				<div class="col-12">
					<DetalleContacto 
						:contacto="contacto"
						@enviarMensaje="enviarMensaje(contacto)"
						@volver="volverListaContactos()"
					/>
				</div>
			</div>
		</template>
	</template>

	<template v-if="filter.visibles === 'chat'">
		<template v-if="!chatDetalle">
			<div class="row mt-3">
				<div class="col-12">
					<ListChat 
						:listaChats="chatFilter"
						@chatSeleccionado="chatSeleccionado"
					/>
				</div>
			</div>
		</template>
		<template v-if="chatDetalle">
			<div class="row flex-grow-1 mt-3">
				<div class="col-12 d-flex flex-column flex-grow-1">
					<DetalleChat
						:chat="chat"
						@chatDeleted="chatDeleted"
						@volver="volverListaChats"
					/>
				</div>
			</div>
		</template>
	</template>


</section>
</template>
